import * as React from "react";

export function SecurityBadgeIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
      <g clipPath="url(#clip0_4001_59109)">
        <path d="M16.5 7.33366H15.5833V5.50033C15.5833 2.97033 13.53 0.916992 11 0.916992C8.46996 0.916992 6.41663 2.97033 6.41663 5.50033V7.33366H5.49996C4.49163 7.33366 3.66663 8.15866 3.66663 9.16699V18.3337C3.66663 19.342 4.49163 20.167 5.49996 20.167H16.5C17.5083 20.167 18.3333 19.342 18.3333 18.3337V9.16699C18.3333 8.15866 17.5083 7.33366 16.5 7.33366ZM11 15.5837C9.99163 15.5837 9.16663 14.7587 9.16663 13.7503C9.16663 12.742 9.99163 11.917 11 11.917C12.0083 11.917 12.8333 12.742 12.8333 13.7503C12.8333 14.7587 12.0083 15.5837 11 15.5837ZM13.8416 7.33366H8.15829V5.50033C8.15829 3.93283 9.43246 2.65866 11 2.65866C12.5675 2.65866 13.8416 3.93283 13.8416 5.50033V7.33366Z" fill="#44474C"/>
      </g>
      <defs>
        <clipPath id="clip0_4001_59109">
          <rect width="22" height="22" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
